import React from 'react';
import MasterPage from 'components/MasterPage';
import { useState } from 'react';
import { Container, Form, Row, Col, Card, Button, Modal, Spinner } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Redirect } from 'react-router';
import { apiElite } from 'services';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { Phone, CNPJ } from 'helpers/Input';
import { Currency, currencyReverse} from 'helpers/Currency';
import './style.css';

export default function NewComission() {
  const [form, setForm] = useState({
    channel: '',
    name: '',
    emai: '',
    phone: '',
    company_name: '',
    cnpj: '',
    pending_month: '',
    service_provider: '',
    hired_service: '',
    sign_date: '',
    hire_value: '',
    description: '',
  });
  const [isLoad, setLoad] = useState(false)
  const [end, setEnd] = useState({isEnd:false, isError:false})

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoad(true);
    setEnd({...{isEnd:false, isError:false}});
    apiElite
      .post('comissions', form)
      .then(() => {
        setEnd({...{isEnd:true, isError:false}})
        setTimeout(()=>{
          window.location.href = '/master-agent/my-comissions';
        },3000);
      })
      .catch(()=>{
        setLoad(false)
      });
  };

  return (<>
    <Container>
      <Row className="mt-4">
        <Link to="/master-agent/my-comissions" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-4">
        <WidgetsOutlined className="icon-title" />
        <h5 className="title-dashboard">Inquérito de Comissão</h5>
      </Row>
      <Row className="">
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 pt-4 pb-4 pr-4 pl-4 col-12">
          <Form noValidate className="" onSubmit={handleSubmit}>
            <Row className="">
              <Col md="12">
                <h6 className="title-dashboard">Contestação de Comissão</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Form.Row>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Canal Parceiro</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) =>
                    setForm({ ...form, channel: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) =>
                    setForm({ ...form, emai: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Telefone</Form.Label>
                <Phone
                  onChange={(e) =>
                    setForm({ ...form, phone: e.target.value })
                  }
                />
              </Form.Group>
            </Form.Row>
            <Row className="mt-4">
              <Col md="12">
                <h6 className="title-dashboard">Dados do Cliente Final</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Form.Row>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Razão Social</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) =>
                    setForm({ ...form, company_name: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>CNPJ</Form.Label>
                <CNPJ
                  onChange={(e) => setForm({ ...form, cnpj: e.target.value })}
                />
              </Form.Group>
            </Form.Row>
            <Row className="mt-4">
              <Col md="12">
                <h6 className="title-dashboard">Dados da Contestação</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Form.Row>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Mês de Pendência</Form.Label>
                <div className="">
                  <DatePicker
                    className="form-control"
                    dateFormat="MM/yyyy"
                    selected={form.pending_month}
                    locale="pt-BR"
                    onChange={(date) =>
                      setForm({ ...form, pending_month: date })
                    }
                    showMonthYearPicker
                  />
                </div>
              </Form.Group>
              <Form.Group as={Col} xs="12" md="6">
                <Form.Label>Provedor de Serviço</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) =>
                    setForm({ ...form, service_provider: e.target.value })
                  }
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} xs="12" md="4">
                <Form.Label>Serviço Contratado</Form.Label>
                <Form.Control
                  required
                  type="text"
                  onChange={(e) =>
                    setForm({ ...form, hired_service: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group as={Col} xs="12" md="4">
                <Form.Label>Data Assinatura</Form.Label>
                <div className="">
                  <DatePicker
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    selected={form.sign_date}
                    locale="pt-BR"
                    onChange={(date) => setForm({ ...form, sign_date: date })}
                  />
                </div>
              </Form.Group>
              <Form.Group as={Col} xs="12" md="4">
                <Form.Label>Valor do Contrato</Form.Label>
                <Currency
                  onChange={(e) =>
                    setForm({ ...form, hire_value: currencyReverse(e.target.value) })
                  }
                />
              </Form.Group>
            </Form.Row>
            <Row className="mt-4">
              <Col md="12">
                <h6 className="title-dashboard">Breve Descritivo da Contestação</h6>
              </Col>
              <Col md="12">
                <hr className="line"></hr>
              </Col>
            </Row>
            <Form.Group as={Col} xs="12" md="12">
              <Form.Control
                required
                as="textarea"
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
              />
            </Form.Group>
            <Form.Row className="col-12 pr-0">
              <Form.Group as={Col}>
                <Button block variant="primary" type="submit" disabled={isLoad}>
                  Enviar
                  </Button>
              </Form.Group>
            </Form.Row>
          </Form>
        </Card.Body>
      </Row>
    </Container>
    <Modal show={isLoad}>
      <Modal.Body>
        {!end.isEnd?(
          <div className="d-flex justify-content-center">
            <Spinner animation="border" role="status" 
            style={{height:'50px',width:'50px'}}
            className="p-2"
            >
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ):(
          <div className="d-flex justify-content-center">
            <div className="success">
              <div className="center_success">
                <div className="line1"></div>
                <div className="line2"></div>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-center">
          {!end.isEnd?(
            <span className="p-2">Enviando contestação de comissão.</span>
          ):(
            <span className="p-2">Contestação de comissão enviada com sucesso!</span>
          )}
        </div>
      </Modal.Body>
    </Modal>
  </>);
}
